import { createSelector } from 'reselect'
import { isObject } from 'util'


const sucursales = (state) => state.datosSucursales.DataSucursales
const colores = (state) => state.catalogosCotizacion.colores


export const arraySucursales = createSelector(
    sucursales,
    (lista) => {
        lista.unshift({ id: '', name: 'Seleccione una sucursal' })
        return lista.map(({ sucCodigoCore: id, sucNombre: name, ...res }) => ({ id, name, ...res }))
    }
)


export const formatearColores = createSelector(
    colores,
    (lista) => {



        if (Object.keys(lista).length === 0) return lista = []

        if (lista[0] && ((lista[0].colCodigoCore && lista[0].colCodigoCore !== '') || (lista[0].id && lista[0].id !== ''))) {
            console.log('LISTA', lista)
            lista.unshift({ id: '', name: 'Seleccione un color' })
        }
        return lista.map(({ colCodigoCore: id, colNombre: name, ...res }) => ({ id, name, ...res }))
    }
)

export const formatoReactSelect = (lista = [], id, name) => {
    if (Object.keys(lista).length === 0) {
        return []
    }
    return lista.map(({ [id]: value, [name]: label, ...res }) => ({ value, label, ...res }))
}